import React from 'react';
import { Box, ClassNameMap, Typography } from '@mui/material';
import { makeStyles } from 'tss-react/mui';
import { LoadableTypography } from '@uplift/ui-v2';


const useStyles = makeStyles<Pick<PeriodSummaryCardMSOProps, 'disabled'>>()((theme, props) => ({
  value: {
    display: 'inline-block',
    fontWeight: 700,
    color: props.disabled ? theme.palette.text.disabled : theme.palette.grey[900],
  },
  subtitle: {
    color: theme.palette.grey[500],
  },
}));


export type PeriodSummaryCardMSOProps = {
  value: React.ReactNode;
  subtitle: string;
  classes?: ClassNameMap<'value' | 'subtitle'>;
  disabled?: boolean;
};


export const PeriodSummaryCardMSO: React.FC<PeriodSummaryCardMSOProps> = ({ value, subtitle, ...props }) => {
  const { classes } = useStyles(props, {
    props: props
  });

  return (
    <Box textAlign="center">
      <LoadableTypography
        loading={value === undefined}
        width="80px"
        component="span"
        variant="h3"
        className={classes.value}
      >
        {value}
      </LoadableTypography>
      <Typography className={classes.subtitle}>
        {subtitle}
      </Typography>
    </Box>
  );
};
